import * as React from 'react';
import DataColumn from '../../components/controls/datagrid/DataColumn';
import DataList from '../../components/controls/datagrid/DataList';

type Props = {
    items: any,
    controller: string,
    modal?: React.ReactNode,
    modaltitle?: string,
    modalwidth?: string,
    state?: any
}

export default (props: Props) => {
    return (
        <>
            <DataList items={props.items} modalwidth={props.modalwidth} modaltitle={props.modaltitle} modalController={props.controller} modal={props.modal} state={props.state} >
                <DataColumn kid='column1' name='' fieldName='delete' minWidth={10} maxWidth={10} type='delete' />
                <DataColumn kid='column2' name='Permesso' fieldName='permission_name' minWidth={150} maxWidth={300} align='center' />
                <DataColumn kid='column3' name='Privilegio' fieldName='privilege' minWidth={150} align='center' />
                <DataColumn kid='column3' name='Ruolo' fieldName='role' minWidth={150} align='center' />
                <DataColumn kid='column4' name='' fieldName='edit' minWidth={10} maxWidth={10} type='edit' />
            </DataList>
        </>
    );
}
